import  './index'
import axios from '@/http/axios'

async function changePaymentModel (payload) {
  const token = localStorage.accessToken
  
  return axios.put('/api/user/changePaymentModel', payload, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
async function getUser (payload) {
  const token = localStorage.accessToken
  
  return axios.get(`/api/user/getRestaurant/${  payload.restaurantId}`, {
    headers:{
      Authorization: `Bearer ${token}`
    }
  })
}
export {
  changePaymentModel, getUser
}
